import apiClient from "../../utils/apiClient";

const API_URL = "/admin/form-fields";

// Get all form fields
export async function getAllFormFields() {
    try {
        const response = await apiClient.get(`${API_URL}`, { params: { _t: Date.now() } });
        return response.data;
    } catch (error) {
        console.error("Error fetching form fields:", error);
        throw error;
    }
}

// Get form fields by service ID
export async function getFormFieldsByService(serviceId) {
    try {
        const response = await apiClient.get(`${API_URL}/service/${serviceId}`, { params: { _t: Date.now() } });
        return response.data;
    } catch (error) {
        console.error("Error fetching form fields by service:", error);
        throw error;
    }
}

// Get single form field by ID
export async function getFormFieldById(fieldId) {
    try {
        const response = await apiClient.get(`${API_URL}/${fieldId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching form field:", error);
        throw error;
    }
}

// Create new form field
export async function createFormField(formFieldData) {
    try {
        const response = await apiClient.post(`${API_URL}`, formFieldData);
        return response.data;
    } catch (error) {
        console.error("Error creating form field:", error);
        throw error;
    }
}

// Update form field
export async function updateFormField(fieldId, formFieldData) {
    try {
        const response = await apiClient.put(`${API_URL}/${fieldId}`, formFieldData);
        return response.data;
    } catch (error) {
        console.error("Error updating form field:", error);
        throw error;
    }
}

// Delete form field
export async function deleteFormField(fieldId) {
    try {
        const response = await apiClient.delete(`${API_URL}/${fieldId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting form field:", error);
        throw error;
    }
}

// Toggle form field status
export async function toggleFormFieldStatus(fieldId) {
    try {
        const response = await apiClient.patch(`${API_URL}/${fieldId}/status`);
        return response.data;
    } catch (error) {
        console.error("Error toggling form field status:", error);
        throw error;
    }
}